/**
 * 🚪🔗 carriedSpace — the space a "Bring your own" user came FROM.
 *
 * Nina 09-22: the Add Agent box inside a space links to the quickstart in a
 * new tab, and every quickstart button opened yet another tab. The user ended
 * up with a registered agent three tabs away and no way back except pasting
 * the agent id by hand. The fix: carry the space id through the whole funnel
 * (`/agents/quickstart?space=<id>` → `/agents/import?space=<id>`) so the
 * register page can offer to seat the agent straight into that space.
 *
 * ONE reader on purpose. Both pages call `carriedSpaceFromSearch` so the
 * param name and the uuid gate can never drift between them. The gate is
 * strict: a value that is not a uuid is treated as absent, never forwarded,
 * so a mangled link degrades to the plain quickstart instead of a dead join.
 */

export const CARRIED_SPACE_PARAM = 'space';

const UUID_EXACT_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Uuid-shaped or null. Accepts a raw id, `?space=…`, or a full search string. */
export const carriedSpaceFromSearch = (search) => {
  if (!search || typeof search !== 'string') return null;
  let raw = search.trim();
  if (raw.startsWith('?') || raw.includes('=')) {
    try {
      raw = new URLSearchParams(raw.startsWith('?') ? raw : `?${raw}`).get(CARRIED_SPACE_PARAM) || '';
    } catch (e) {
      return null;
    }
  }
  raw = raw.trim();
  return UUID_EXACT_RE.test(raw) ? raw.toLowerCase() : null;
};

/** Append `?space=<id>` to a path, only when the id passes the gate. */
export const withCarriedSpace = (path, gameId) => {
  const id = carriedSpaceFromSearch(gameId);
  if (!id) return path;
  const sep = path.includes('?') ? '&' : '?';
  const [base, hash] = path.split('#');
  return `${base}${sep}${CARRIED_SPACE_PARAM}=${id}${hash ? `#${hash}` : ''}`;
};

/** The canonical space route (reference_space_url_formats: /game-step?gameId= is canonical). */
export const spacePath = (gameId) => `/game-step?gameId=${gameId}`;
